export interface IPFactory {
  /*
   * IPFactory
   *
   * 사업장(공장) 정보를 담은 클래스 - 가장 상위의 클래스
   *
   */

  // DB Field
  uid: number; // 고유 ID - Primary Key
  creatorUID: number; // 생성자 uid
  name: string;
  initial: string; // 사업장 코드 - 약자
  description: string; // 사업장 설명
  logoFile: string; // 로고 이미지 파일명

  isDeleted?: boolean; //  삭제 여부

  entryDate?: Date;
  modifyDate?: Date;
  deleteDate?: Date;

  // Non DB
  base64: string;
  creatorName: string;
}

// 초기값
export const initializeIPFactory: IPFactory = {
  uid: 0,
  creatorUID: 0,
  name: "",
  initial: "",
  description: "",
  logoFile: "",
  isDeleted: false,
  entryDate: new Date(),
  modifyDate: new Date(),
  deleteDate: new Date(1900, 1, 1),
  base64: "",
  creatorName: "",
};

// 요청 패러미터
export interface IPFactoryListRequest {
  userToken?: string; // 사용자 식별 값
  page?: number; // 페이지 번호 (옵션 : 기본값 1)
  rowCount?: number; // 한 페이지에 표시되는 개수 (옵션 : 기본값 30)
  searchWord?: string; // 검색어 (옵션)
}
export interface IPCreateFactoryRequest {
  userToken: string; // 사용자 식별 값
  item: Partial<IPFactory>;
}

// note 2022-02-03 SmokingScully가 추가
export interface IPDeleteFactoryRequest {
  userToken: string; // 사용자 식별 값
  id: number; // 삭제할 아이템의 UID값
}